const Cleave = require('cleave.js');

module.exports = {
    handleCreditCardNumber(cardFieldSelector, cardTypeSelector) {
        const creditCardTypes = {
            visa: 'Visa',
            mastercard: 'Master Card',
            amex: 'Amex',
            unknown: 'Unknown'
        };

        function checkCardType(type) {
            const cardType = creditCardTypes[Object.keys(creditCardTypes).indexOf(type) > -1
                ? type
                : 'unknown'];
            return cardType;
        }

        function setSecurityCodeLength(typeOfCard) {
            if (typeOfCard === 'visa' || typeOfCard === 'mastercard') {
                $('#securityCode').attr('maxlength', 3);
            } else {
                $('#securityCode').attr('maxlength', 4);
            }
        }

        function createCleave() {
            const cleave = new Cleave.default(cardFieldSelector, {
                creditCard: true,
                onCreditCardTypeChanged(type) {
                    const cardType = checkCardType(type);
                    $(cardTypeSelector).val(cardType);
                    $('.card-number-wrapper').attr('data-type', type);
                    setSecurityCodeLength(type);

                    if (type === 'Visa') {
                        this.destroy();
                        window.createCleaveForVisa();
                    }
                }
            });
            $(cardFieldSelector).data('cleave', cleave);
        }

        window.createCleaveForVisa = function () {
            const cleaveForVisa = new Cleave.default(cardFieldSelector, {
                creditCard: true,
                creditCardStrictMode: true,
                onCreditCardTypeChanged(type) {
                    const cardType = checkCardType(type);
                    $(cardTypeSelector).val(cardType);
                    $('.card-number-wrapper').attr('data-type', type);

                    if (type !== 'Visa') {
                        this.destroy();
                        createCleave();
                    }
                }
            });
            $(cardFieldSelector).data('cleave', cleaveForVisa);
        };

        createCleave();

    },

    serializeData(form) {
        var serializedArray = form.serializeArray();

        serializedArray.forEach((item) => {
            if (item.name.indexOf('cardNumber') > -1) {
                item.value = $('#cardNumber').data('cleave').getRawValue(); // eslint-disable-line
            }
        });

        serializedArray = serializedArray.filter((item) => {
            return item.name.indexOf('securityCode') === -1 || item.value !== '';
        });

        return $.param(serializedArray);
    },

    handlePostalCode: function (postalCodeInput) {
        var cleave = new Cleave.default(postalCodeInput, {
            blocks: [3, 3],
            uppercase: true
        });

        $(postalCodeInput).data("cleave", cleave);
    }
};
